import Vue from 'vue';

const ConvertTimestamp = {
  install(): void {
    Vue.prototype.convertTimestamp = (timestamp: number | string, onlyDate?: boolean): string => {
      let res;
      if (!isNaN(Number(timestamp))) {
        res = new Date(Number(timestamp) * 1000).toLocaleString('en-gb').replace(',', '');
      } else {
        res = new Date(timestamp).toLocaleString('en-gb').replace(',', '');
      }

      if (onlyDate) {
        res = res.substring(0, 10);
      }

      return res;
    };
  },
};

export default ConvertTimestamp;
